import React from 'react'
import './SearchResults.scss'

import SearchResultCard from '../search-results-card/SearchResultsCard'
import { useSearchContext } from '../../context/search.context'
import CustomPagination from '../pagination/CustomPagination'
import SearchHeader from './search-header/SearchHeader'
import { isLight } from '../../Common'

const SearchResults = () => {
  const {
    searchResultData: searchData,
    handlePagination,
    loading,
    searchValue
  } = useSearchContext()

  if (loading) {
    return (
      <div className='search-result-page'>
        {' '}
        <div className='loader'></div>
      </div>
    )
  }

  return (
    <div className='search-result-page'>
      <SearchHeader showCountVisible={(searchData?.hits?.hits?.length ?? 0) > 0} />
      <div
        className={`list-view listing-page list-view--search-results ${!isLight && 'list-view--inverted'}`}
      >
        <div className='container'>
          <div className='row'>
            {searchData?.hits.hits.map((item) => <SearchResultCard data={item} key={item._id} />)}
          </div>

          {(searchData?.hits?.hits?.length ?? 0) > 0 &&
            (searchData?.hits?.total?.value ?? 0) > 10 && (
              <CustomPagination
                total={searchData?.hits.total.value || 0}
                pageSize={10}
                handleOnChange={(page) => {
                  handlePagination(page)
                }}
              />
            )}
        </div>
      </div>
      {searchData?.hits?.hits?.length == 0 && (
        <div className='search-noresult'>
          <div className='search-noresult__content'>
            <div className='search-noresult__title'>We are sorry...</div>
            <div className='search-noresult__desc'>There are no search results for</div>
            <div className='search-noresult__sub-desc'>‘{searchValue}’</div>
          </div>
        </div>
      )}
    </div>
  )
}

export default SearchResults
